module.exports = __webpack_public_path__ + "img/microsoft.5a65210d.svg";